import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { CoreTargetService } from '../core/services/target.service';

@Injectable({
  providedIn: 'root',
})
export class RecordingsService {
  constructor(
    private _http: HttpClient,
    private coreTargetService: CoreTargetService,
  ) {}

  behamicsSample: boolean = false;
  getTargetFromLocalStorage() {
    let target = this.coreTargetService.getSelectedTarget('target');

    if (target == 'behamicsSample') {
      target = 'behamicsWeb';
      this.behamicsSample = true;
    } else {
      this.behamicsSample = false;
    }

    return target;
  }

  getScreenRecorders(params: any): Observable<any> {
    this.getTargetFromLocalStorage();

    if (this.behamicsSample) {
      params['target'] = 'behamicsWeb';
      params['behamicsSample'] = true;
    }

    if (params['signals'] && this.behamicsSample) {
      delete params['behamicsSample'];
      params['target'] = 'behamicsSampleSignals';
    }

    return this._http.post(`/recorder/sessions`, params);
  }
  getRecordedSession(id: string, target: string): Observable<any> {
    this.getTargetFromLocalStorage();

    let params = `videoID=${id}&target=${target}`;

    if (this.behamicsSample) {
      target.replace('behamicsSample', 'behamicsWeb');
      params += '&behamicsSample=true';
    }

    return this._http.get(`/recorder/session?${params}`);
  }
  getCampaigns(target: string): Observable<any> {
    this.getTargetFromLocalStorage();

    let params = `target=${target}`;
    if (this.behamicsSample) {
      params.replace('behamicsSample', 'behamicsWeb');
      params += '&behamicsSample=true';
    }

    return this._http.get('/recorder/campaigns?' + params);
  }
  addCampaign(campaign: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      campaign['target'] = 'behamicsWeb';
      campaign['behamicsSample'] = 'true';
    }

    return this._http.post('/recorder/setup-campaign', campaign);
  }
  editCampaign(campaign: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      campaign['target'] = 'behamicsWeb';
      campaign['behamicsSample'] = 'true';
    }
    return this._http.put('/recorder/setup-campaign/edit', campaign);
  }
  toggleCampaign(data: any, checked: boolean): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      data['target'] = 'behamicsWeb';
      data['behamicsSample'] = 'true';
    }
    if (checked) {
      return this._http.post('/recorder/setup-campaign/activate', data);
    }
    return this._http.post('/recorder/setup-campaign/deactivate', data);
  }

  // heatmaps
  getHeatmaps(params: string): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      params.replace('behamicsSample', 'behamicsWeb');
      params += '&behamicsSample=true';
    }
    return this._http.get('/recorder/heatmaps' + params);
  }
  createHeatmap(data: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      data['target'] = 'behamicsWeb';
      data['behamicsSample'] = 'true';
    }
    return this._http.post('/recorder/heatmaps/create', data);
  }
  getHeatmapUrls(params: string, paramsObj?: any): Observable<any> {
    this.getTargetFromLocalStorage();

    if (this.behamicsSample) {
      return this._http.post(
        '/recorder/heatmaps/urls?target=behamicsWeb&behamicsSample=true',
        paramsObj || {},
      );
    } else {
      return this._http.post(
        '/recorder/heatmaps/urls' + params,
        paramsObj || {},
      );
    }
  }
  getDomains(params: string, paramsObj?: any): Observable<any> {
    this.getTargetFromLocalStorage();

    if (this.behamicsSample) {
      return this._http.post(
        '/recorder/referrers?target=behamicsWeb&behamicsSample=true',
        paramsObj || {},
      );
    } else {
      return this._http.post('/recorder/referrers' + params, paramsObj || {});
    }
  }
  editHeatmap(data: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      data['target'] = 'behamicsWeb';
      data['behamicsSample'] = 'true';
    }
    return this._http.put('/recorder/heatmaps/edit', data);
  }
  fetchHeatmapClickData(params: string): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      params.replace('behamicsSample', 'behamicsWeb');
      params += '&behamicsSample=true';
    }
    return this._http.get('/recorder/coordinates?' + params);
  }
  fetchHeatmapScrollData(params: string): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      params.replace('behamicsSample', 'behamicsWeb');
      params += '&behamicsSample=true';
    }
    return this._http.get('/recorder/scrolldata?' + params);
  }
  getSuggestedScreenshots(params: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      params['target'] = 'behamicsWeb';
      params['behamicsSample'] = true;
    }
    return this._http.post('/recorder/heatmaps/screenshot', params);
  }
  deleteHeatmaps(location: string, target: string): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      target = 'behamicsWeb';
    }
    return this._http.delete('/recorder/heatmaps/delete', {
      body: { location: location, target: target },
    });
  }
  saveComments(data: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      data['target'] = 'behamicsWeb';
      data['behamicsSample'] = true;
    }
    return this._http.post('/recorder/comments-collections', data);
  }
  getComment(target: string, videoID: string): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      target = 'behamicsWeb';
    }
    return this._http.get(
      `/recorder/comments?target=${target}&videoID=${videoID}`,
    );
  }
  deleteComment(data: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      data['target'] = 'behamicsWeb';
      data['behamicsSample'] = true;
    }
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        ...data,
      },
    };
    return this._http.delete(`/recorder/comment`, options);
  }
  getCommentCollection(target: string): Observable<any> {
    this.getTargetFromLocalStorage();
    let params = `target=${target}`;
    if (this.behamicsSample) {
      params.replace('behamicsSample', 'behamicsWeb');
      params += '&behamicsSample=true';
    }
    return this._http.get(`/recorder/collections?${params}`);
  }
  deleteCommentCollection(data: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      data['target'] = 'behamicsWeb';
      data['behamicsSample'] = true;
    }
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: {
        ...data,
      },
    };
    return this._http.delete(`/recorder/collection`, options);
  }

  getSessionFilters(body: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      body['target'] = 'behamicsWeb';
      body['behamicsSample'] = 'true';
    }

    let params = new HttpParams();

    Object.keys(body).forEach((key) => {
      const value = body[key];
      if (value !== null && value !== undefined) {
        params = params.set(key, value);
      }
    });

    return this._http.get('/recorder/session-filters', { params });
  }

  getAIChatHistory(paramsObj: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      paramsObj['target'] = 'behamicsWeb';
      paramsObj['behamicsSample'] = 'true';
    }

    if (paramsObj['signals'] && this.behamicsSample) {
      delete paramsObj['behamicsSample'];
      paramsObj['target'] = 'behamicsSampleSignals';
    }

    let params: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this._http.get('/recorder/get-all-chats' + params);
  }

  createAIChat(paramsObj: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      paramsObj['target'] = 'behamicsWeb';
      paramsObj['behamicsSample'] = 'true';
    }
    return this._http.post('/recorder/create-chat', paramsObj);
  }

  deleteAIChat(paramsObj: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      paramsObj['target'] = 'behamicsWeb';
      paramsObj['behamicsSample'] = 'true';
    }

    let params: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this._http.get('/recorder/delete-chat' + params);
  }

  getAIChat(paramsObj: any): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      paramsObj['target'] = 'behamicsWeb';
      paramsObj['behamicsSample'] = 'true';
    }

    if (paramsObj['signals'] && this.behamicsSample) {
      paramsObj['target'] = 'behamicsSampleSignals';
    }

    let params: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this._http.get('/recorder/get-chat' + params);
  }
  askAI(formData: FormData): Observable<any> {
    this.getTargetFromLocalStorage();
    if (this.behamicsSample) {
      formData.append('target', 'behamicsWeb');
      formData.append('behamicsSample', 'true');
    }
    return this._http.post('/recorder/ask-ai', formData);
  }
}
